<template>
    <v-dialog v-model="modalProp" persistent max-width="400">
        <v-card>
            <v-card-title
                class="headline green accent-4 white--text elevation-7"
            />
            <div style="width:90%; margin:auto" class="">
                <v-card-text class="py-8 text-center subtitle-2">
                    <h4 class="mb-5">
                        Click the button to create your account now!
                    </h4>
                    <v-btn
                        color="green accent-3 white--text"
                        @click="
                            (modalProp = !modalProp),
                            showForm(createAccountForm, hideLoginSignup)
                        "
                    >
                        Create Account
                    </v-btn>
                </v-card-text>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    props: ['doesntExist', 'resultData', 'createAccountForm'],
    data: () => ({}),
    computed: {
        ...mapGetters(['hideLoginSignup']),
        modalProp: {
            get() {
                return this.doesntExist
            },
            set(val) {
                this.$emit('pop-yesDoesntExist', val)
            }
        }
    },
    methods: {
        ...mapActions(['showCreateAccountForm']),
        showForm(val, _) {
            this.showCreateAccountForm(val)
        }
    }
}
</script>

<style></style>
